export const toTitleItemId = (pageId: string) => `--title:${pageId}`;
export const toMessageItemId = (pageId: string) => `--msg:${pageId}`;
export const toMessageComponentId = (pageId: string, i: number) => `--msg:${pageId}:${i}`;
export const toOrderedComponentId = (pageId: string, i: number) => `--cmp:${pageId}:${i}`;
export const toOkButtonComponentId = (pageId: string) => `--ok:${pageId}`;
